import React from 'react'

const Settings = () => {
  return (
    <div className='w-full h-full'>Settings</div>
  )
}

export default Settings